module.exports = __webpack_public_path__ + "static/img/3.f74d3e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/3.png
// module id = 7+e4
// module chunks = 1